// Tag for graphql format
const gql = String.raw;

// Fragments
import {
	CallActivityPerformanceFragment,
	CustomerSatisfactionStoreFragment,
	LongevityFragment,
	TopPerformerBonusFragment,
	UserFullNameFragment,
	BonusDefinitionFragment,
	CommissionTiersFragment,
	MetricFragment,
	InputValueFragment,
	VariableOperationsGpsBonusSetupFragment,
} from "@PayPlans/api/fragments/commons";

import {
	CashAndLeaseBumpFragment,
	CITBonusesFragment,
	DefaultCommissionsFragment,
	DepartmentOverrideNetIncomeFragment,
	MaxPayoutFragment,
	ProductBonusesFragment,
	PVRQualifierFragment,
} from "@PayPlans/api/fragments/managers/finance";

export const onCreateFinanceManagerPayPlan = gql`
	subscription onCreateFinancePayPlan($locationId: String, $position: String) {
		onCreateFinancePayPlan(locationId: $locationId, position: $position) {
			_id
			locationId
			name
			position
			backendPVRComputation
			default {
				...FinanceDefaultCommissions
			}
			productBonuses {
				...ProductBonuses
			}
			cashAndLeaseBump {
				...CashAndLeaseBump
			}
			callActivityPerformance {
				...CallActivityPerformance
			}
			cit {
				...CITBonuses
			}
			customerSatisfaction {
				...CustomerSatisfactionStore
			}
			departmentOverrideNetIncome {
				...DepartmentOverrideNetIncome
			}
			pvrQualifier {
				...PVRQualifier
			}
			topSalesBonus {
				...TopPerformerBonus
			}
			maxPayout {
				...MaxPayout
			}
			longevity {
				...Longevity
			}
			variableOperationsGpsBonus {
				...VariableOperationsGpsBonusSetup
			}
			locked
			formatVersion
			locked
			createdAt
			createdBy {
				...UserFullName
			}
			updatedAt
			updatedBy {
				...UserFullName
			}
		}
	}
	${DefaultCommissionsFragment}
	${ProductBonusesFragment}
	${CashAndLeaseBumpFragment}
	${CallActivityPerformanceFragment}
	${CITBonusesFragment}
	${CustomerSatisfactionStoreFragment}
	${DepartmentOverrideNetIncomeFragment}
	${PVRQualifierFragment}
	${TopPerformerBonusFragment}
	${MaxPayoutFragment}
	${LongevityFragment}
	${UserFullNameFragment}
	${BonusDefinitionFragment}
	${CommissionTiersFragment}
	${MetricFragment}
	${InputValueFragment}
	${VariableOperationsGpsBonusSetupFragment}
`;

export const onCloneFinanceManagerPayPlan = gql`
	subscription onCloneFinancePayPlan($locationId: String, $position: String) {
		onCloneFinancePayPlan(locationId: $locationId, position: $position) {
			_id
			locationId
			name
			position
		}
	}
`;

export const onUpdateFinanceAvailablePayPlan = gql`
	subscription onUpdateFinanceAvailablePayPlan($locationId: String, $_id: String, $position: String) {
		onUpdateFinanceAvailablePayPlan(locationId: $locationId, _id: $_id, position: $position) {
			_id
			available
			name
			position
		}
	}
`;

export const onDeleteFinanceManagerPayPlan = gql`
	subscription onDeleteFinancePayPlan($locationId: String, $position: String) {
		onDeleteFinancePayPlan(locationId: $locationId, position: $position) {
			_id
			locationId
		}
	}
`;

export const onUpdateFinanceManagerPayPlan = gql`
	subscription onUpdateFinancePayPlan($locationId: String, $_id: String, $position: String) {
		onUpdateFinancePayPlan(locationId: $locationId, _id: $_id, position: $position) {
			_id
			locationId
			name
			position
			backendPVRComputation
			default {
				...FinanceDefaultCommissions
			}
			productBonuses {
				...ProductBonuses
			}
			cashAndLeaseBump {
				...CashAndLeaseBump
			}
			callActivityPerformance {
				...CallActivityPerformance
			}
			cit {
				...CITBonuses
			}
			customerSatisfaction {
				...CustomerSatisfactionStore
			}
			departmentOverrideNetIncome {
				...DepartmentOverrideNetIncome
			}
			pvrQualifier {
				...PVRQualifier
			}
			topSalesBonus {
				...TopPerformerBonus
			}
			maxPayout {
				...MaxPayout
			}
			longevity {
				...Longevity
			}
			variableOperationsGpsBonus {
				...VariableOperationsGpsBonusSetup
			}
			locked
			formatVersion
			locked
			createdAt
			createdBy {
				...UserFullName
			}
			updatedAt
			updatedBy {
				...UserFullName
			}
		}
	}
	${DefaultCommissionsFragment}
	${ProductBonusesFragment}
	${CashAndLeaseBumpFragment}
	${CallActivityPerformanceFragment}
	${CITBonusesFragment}
	${CustomerSatisfactionStoreFragment}
	${DepartmentOverrideNetIncomeFragment}
	${PVRQualifierFragment}
	${TopPerformerBonusFragment}
	${MaxPayoutFragment}
	${LongevityFragment}
	${UserFullNameFragment}
	${BonusDefinitionFragment}
	${CommissionTiersFragment}
	${MetricFragment}
	${InputValueFragment}
	${VariableOperationsGpsBonusSetupFragment}
`;
